import fs from 'fs';
import { createHash } from 'crypto';
import { parentPort } from 'worker_threads';

if (!parentPort) {
  throw new Error('WorkerThread must be run as a worker');
}

type HashRequest = {
  type: 'hash';
  taskId: number;
  absPath: string;
  relPath: string;
};

type HashResponse =
  | {
      type: 'hash-result';
      taskId: number;
      contentSha256: string;
      serviceFileHash: string;
    }
  | {
      type: 'hash-error';
      taskId: number;
      error: string;
      code?: string;
    };

function hashFile(
  absPath: string,
  relPath: string,
): Promise<{ content: string; service: string }> {
  return new Promise((resolve, reject) => {
    const content = createHash('sha256');
    const service = createHash('sha256');
    service.update(relPath);
    service.update('\n');

    const stream = fs.createReadStream(absPath);
    stream.on('data', (chunk) => {
      content.update(chunk);
      service.update(chunk);
    });
    stream.on('error', (error) => {
      reject(error);
    });
    stream.on('end', () => {
      resolve({
        content: content.digest('hex'),
        service: service.digest('hex'),
      });
    });
  });
}

parentPort.on('message', async (message: HashRequest) => {
  if (message.type !== 'hash') return;
  try {
    const hashes = await hashFile(message.absPath, message.relPath);
    const response: HashResponse = {
      type: 'hash-result',
      taskId: message.taskId,
      contentSha256: hashes.content,
      serviceFileHash: hashes.service,
    };
    parentPort?.postMessage(response);
  } catch (error: any) {
    const response: HashResponse = {
      type: 'hash-error',
      taskId: message.taskId,
      error: error?.message ?? String(error),
      code: error?.code,
    };
    parentPort?.postMessage(response);
  }
});

export {};
